'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ErrorMessages=require('../../../../../../../dist-es6/client/errorMessages');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ActivityCodeSearchDirective=function(_BaseControllerBacked){_inherits(ActivityCodeSearchDirective,_BaseControllerBacked);function ActivityCodeSearchDirective(){_classCallCheck(this,ActivityCodeSearchDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ActivityCodeSearchDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/activityCodeSearchDirective/activityCodeSearchTemplate'}},{key:'objectBindings',get:function()

{return['onSelectCode','excludedResults']}},{key:'optionalObjectBindings',get:function()

{return['query','newActivityCode','results']}},{key:'$inject',get:function()

{return['$scope','$timeout','socketService','notificationService']}},{key:'controller',get:function()

{return ActivityCodeSearchController}}]);return ActivityCodeSearchDirective}(BaseControllerBackedDirective);


const ControllerDefaults={
query:'',
results:[],
excludedResults:[],
newActivityCode:null,
onSelectCode:_.noop};let


ActivityCodeSearchController=function(){
function ActivityCodeSearchController($scope,$timeout,socketService,notificationService){var _this2=this;_classCallCheck(this,ActivityCodeSearchController);
this._$scope=$scope;
this._$timeout=$timeout;
this._socketService=socketService;
this._notificationService=notificationService;

_.defaults(this,ControllerDefaults);

this._$scope.$watch('controller.newActivityCode',function(newCode,oldCode){
if(!_.exists(newCode)||_.exists(oldCode)&&newCode===oldCode){
return;
}

_this2.onSelectCode(newCode);
_this2.newActivityCode=null;
});

this.getResultsForActivityCodeSearch=this._getResultsForActivityCodeSearch.bind(this);
}ActivityCodeSearchController.prototype.

_getResultsForActivityCodeSearch=function(){var ref=_asyncToGenerator(function*(query){var _this3=this;
if(!_.exists(query)||query.length===0){
return[];
}

const socketResponse=yield this._socketService.sendAndWaitForResponse('ActivityCodeSearch',{query:query});

if(!SocketResponse.succeeded(socketResponse)){
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
return[];
}

return socketResponse.body.results.filter(function(r){return _this3.excludedResults.indexOf(r)===-1});
});function _getResultsForActivityCodeSearch(query){return ref.apply(this,arguments)}return _getResultsForActivityCodeSearch}();return ActivityCodeSearchController}();


module.exports=ActivityCodeSearchDirective;
//# sourceMappingURL=activityCodeSearchDirective.js.map
